<!-- inicio de desktop-->
<template>
  <v-container class="pa-0"
               fluid
               full-height>
    <v-row class="full-height"
           no-gutters>
      <v-col class="full-height"
             cols="12">
        <v-row class="full-height"
               no-gutters>
          <!-- inicio de sidebar -->
          <v-col class="smartbell-sidebar pa-0 full-height"
                 cols="2">
          </v-col>
          <!-- fin de sidebar -->
          <v-snackbar
              v-model="groupSnackActive"
              color="#EB004E"
              :timeout="1500">
            {{groupSnackText}}
            <template v-slot:action="{ attrs }">
              <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="groupSnackActive = false">
                Cerrar
              </v-btn>
            </template>
          </v-snackbar>
          <v-col class="full-height std-background-white-1"
                 cols="10">
            <!-- inicio de barra superior -->
            <v-row align="end"
                   class="pl-6 pr-12 cow-top-container mt-3 mb-6"
                   justify="space-between"
                   no-gutters>
              <!-- inicio de botón de regresar -->
              <v-col class="d-flex align-end" cols="3">
              </v-col>
              <!-- fin de botón de regresar -->
              <!-- inicio de cambiar de rancho -->
              <v-col cols="3">
                <ChangeRanch></ChangeRanch>
              </v-col>
              <!-- fin de cambiar de rancho -->
              <!-- inicio de tarjeta de vacas en sistema -->
              <v-col cols="3">
              </v-col>
              <!-- fin de tarjeta de vacas en sistema -->
            </v-row>
            <!-- fin de barra superior -->

            <v-row align="center"
                   class="std-container py-0 ml-6 mr-12 std-background-white-1 std-container-shadow"
                   no-gutters>
              <v-col
                  style="position: relative"
                  class="std-border-radius std-title-card-container d-flex align-center justify-center std-background-blue-2"
                     cols="12">
                <div class="col-2"
                     style="position: absolute; left: 4px">
                  <v-btn class="d-flex justify-space-around std-btn-back button-container std-text-white-1"
                         block
                         @click.native="backToDashGroup()"
                         color="#1460AA"
                         depressed>
                    <div class="d-flex justify-space-between align-center">
                      <i class="std-cow-icon std-back-icon-white mr-4"></i>
                      Regresar
                    </div>
                  </v-btn>
                </div>
                <div class="d-flex col-4 justify-center align-center pa-0" >
                  <div class="std-text-lg std-text-white-1 font-weight-bold">Alta de potrero</div>
                </div>
              </v-col>

              <!-- inicio contenedor de inputs 1 -->
              <v-col cols="12"
                     class="gf-inputs-container"
                     v-if="step === 1">
                <v-form v-model="validOne" ref="formOne">
                  <v-row class="mx-6" no-gutters>
                    <!-- inicio de título de primer bloque de inputs -->
                    <v-col cols="12" class="my-2">
                      <div class="std-text-blue-2 font-weight-bold"
                           style="font-size: 20px">Creación de potrero
                      </div>
                    </v-col>
                    <!-- fin de título de primer bloque de inputs -->
                    <!-- inicio de primer bloque de inputs -->
                    <v-col class="pa-0" cols="12">
                      <v-row no-gutters>
                        <!-- inicio nombre potrero -->
                        <v-col class="d-flex flex-wrap"
                               cols="4">
                          <div class="col-12 std-text-md std-text-blue-2 pa-0">Nombre del potrero</div>
                          <v-text-field
                              dense
                              flat
                              v-model="newGroup.name"
                              :rules="nameRules"
                              hide-details
                              outlined
                              placeholder="Grupo increíble"
                              required
                          ></v-text-field>
                        </v-col>
                        <!-- fin nombre potrero -->
                        <!-- inicio tipo potrero -->
                        <v-col class="d-flex flex-wrap"
                               cols="5"
                               v-if="false"
                               offset="1">
                          <div class="col-12 pa-0 std-text-md std-text-blue-2 pa-0">Tipo de nombre</div>
                          <div class="col-12 pa-0 d-flex std-text-xs font-weight-medium justify-space-between">
                            <DashGroupTypeInput text="Preconfigurado"
                                                v-ripple
                                                @click.native="type = 'pre'"
                                                :class="{'std-disabled' : type !== 'pre'}"
                                                class="col-5 pa-0">
                            </DashGroupTypeInput>
                            <DashGroupTypeInput text="Personalizado"
                                                v-ripple
                                                @click.native="type = 'per'"
                                                :class="{'std-disabled' : type !== 'per'}"
                                                class="col-5 pa-0 offset-1">
                            </DashGroupTypeInput>
                          </div>
                        </v-col>
                        <!-- fin tipo potrero -->
                        <!-- inicio descripción -->
                        <v-col class="d-flex flex-wrap pt-2"
                               cols="10">
                          <div class="col-12 std-text-md std-text-blue-2 pa-0">Descripción</div>
                          <v-textarea
                              height="178px"
                              dense
                              :rules="nameRules"
                              flat
                              v-model="newGroup.description"
                              hide-details
                              outlined
                              placeholder="Holstein"
                              required>
                          </v-textarea>
                        </v-col>
                        <!-- fin descripción -->
                        <!-- inicio selección de vacas -->
                        <v-col class="d-flex flex-wrap pt-2"
                               cols="10">
                          <div class="col-12 std-text-md std-text-blue-2 pa-0">Selección de vacas</div>
                          <div class="col-5 std-text-sm std-text-white-1 pa-0 justify-space-between d-flex flex-wrap">
                            <DashGroupTypeInput text="Manual"
                                                @click.native="updateSelection('man')"
                                                v-ripple
                                                :class="{'std-disabled' : filterType !== 'man'}"
                                                class="gf-mid-item">
                            </DashGroupTypeInput>
                            <DashGroupTypeInput text="Automático"
                                                v-ripple
                                                @click.native="updateSelection('aut')"
                                                :class="{'std-disabled' : filterType !== 'aut'}"
                                                class="gf-mid-item">
                            </DashGroupTypeInput>
                          </div>
                        </v-col>
                        <!-- fin selección de vacas -->
                        <!-- inicio filtro a aplicar a la selección -->
                        <v-col class="d-flex flex-wrap pt-2"
                               :class="{'std-disabled' : filterType === 'man'}"
                               cols="10">
                          <div class="col-12 std-text-md std-text-blue-2 pa-0">Filtro a aplicar a la selección</div>
                          <div class="col-4 std-text-sm std-text-white-1 pa-0 d-flex justify-space-between">
                            <v-select
                                dense
                                flat
                                :rules="this.filterType === 'man' ? [] : nameRules"
                                v-model="filterSlt"
                                :items="filterOptions"
                                :disabled="filterType === 'man'"
                                hide-details
                                outlined
                                placeholder="Raza"
                                required
                            ></v-select>
                          </div>
                          <div class="col-8 std-text-sm font-weight-bold pa-0 d-flex flex-wrap align-center"
                               :disabled="filterType === 'man'"
                               v-if="filterSlt !== 'breed' && filterSlt !== null"
                               style="height: 40px">
                            <v-checkbox dense
                                        v-for="(item, index) in filterSltOptions"
                                        hide-details
                                        :rules="ageRule"
                                        :value="item"
                                        :key="index"
                                        v-model="filterSndSlt"
                                        class="pa-0 mx-3 ma-0">
                              <template v-slot:label>
                                <div class="std-text-blue-2">{{filterSltLabels[index]}}</div>
                              </template>
                            </v-checkbox>
                          </div>
                          <div v-if="filterSlt === 'breed'"
                               class="col-4 pa-0 ml-4">
                            <v-select
                                dense
                                flat
                                v-model="filterSndSlt"
                                :rules="nameRules"
                                :items="breeds"
                                hide-details
                                outlined
                                placeholder="Holstein"
                                required
                            ></v-select>
                          </div>
                        </v-col>
                        <!-- fin  filtro a aplicar a la selección -->
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
              <!-- fin contenedor de inputs 1 -->

              <!-- inicio contenedor de inputs 2 -->
              <v-col cols="12" class="gf-inputs-container" v-if="step === 2">
                <v-row class="mx-6" no-gutters>
                  <!-- inicio de título de primer bloque de inputs -->
                  <v-col cols="12" class="d-flex align-center my-2">
                    <div class="mb-2 std-text-blue-2 font-weight-bold col-3 pa-0"
                         style="font-size: 20px">{{newGroup.name}}
                    </div>
                  </v-col>
                  <!-- fin de título de primer bloque de inputs -->
                  <!-- inicio descripción -->
                  <v-col class="pa-0 mb-5"
                         cols="12">
                    <v-text-field
                        dense
                        flat
                        v-model="newGroup.description"
                        hide-details
                        outlined
                        placeholder="Descripción"
                        required>
                    </v-text-field>
                  </v-col>
                  <!-- fin descripción -->
                  <v-col class="pa-0 mb-5 text-center std-text-blue-2 std-text-md"
                         cols="12">
                    Selecciona las vacas a agregar al potrero
                  </v-col>
                  <v-col cols="12"
                         class="d-flex justify-space-between gf-tables-container align-center">
                    <div class="gf-mid-item">
                      <div class="d-flex align-center justify-center gf-mid-item-header
                      mb-2 std-text-md std-text-blue-2 font-weight-bold">
                        Vacas disponibles
                      </div>
                      <div style="height: 265px">
                        <v-row no-gutters
                               class="unselectable mx-2">
                          <!-- inicio header tabla -->
                          <v-col cols="12"
                                 class="d-flex std-text-md-open font-weight-medium">
                            <div class="std-table-header col-12 pa-0 d-flex">
                              <div class="col-6 pa-0 align-center justify-center d-flex"
                                   style="position: relative">
                                <div class="d-flex align-center justify-center"
                                     style="position: absolute; left: 0">
                                  <v-checkbox dark
                                              dense
                                              v-model="allSelected"
                                              class="pa-0 ma-0 ml-4"
                                              hide-details>
                                  </v-checkbox>
                                </div>
                                ID Vaca
                                <i :class="{'icon-anim' : idSortedIcon}"
                                   @animationend="idSortedIcon = false"
                                   class="std-vertical-arrow-icon std-pointer">
                                </i>
                              </div>
                              <div class="col-6 pa-0 align-center justify-center d-flex">
                                Filtro
                                <i :class="{'icon-anim' : filterSortedIcon}"
                                   @animationend="filterSortedIcon = false"
                                   class="std-vertical-arrow-icon std-pointer">
                                </i>
                              </div>
                            </div>
                          </v-col>
                          <!-- fin header tabla -->
                          <!-- inicio contenido -->
                          <v-col cols="12"
                                 class="table-content px-2 gf-table-content gf-draggable-content std-border-bottom-radius">
                            <v-row no-gutters
                                   class="mt-2"
                                   align-content="start">
                              <draggable :list="filteredAnimals"
                                         group="animals"
                                         v-bind="dragOptions"
                                         class="d-flex col-12 pa-0 flex-wrap"
                                         @start="drag = true"
                                         @end="drag = false">
                                <transition-group type="transition"
                                                  :name="!drag ? 'flip-list' : null"
                                                  class="d-flex col-12 pa-0 flex-wrap">
                                  <v-col cols="12"
                                         v-ripple
                                         v-for="item in filteredAnimals"
                                         :key="item.idInternal"
                                         class="std-table-row-container pa-0 d-flex std-text-md-open std-text-gray-3 std-pointer">
                                    <div class="col-6 pa-0 align-center justify-center d-flex flex-wrap"
                                         style="position: relative">
                                      <div class="d-flex align-center justify-center"
                                           style="position: absolute; left: 0">
                                        <v-checkbox dense
                                                    :value="item"
                                                    v-model="selectedAnimals"
                                                    class="pa-0 ma-0 ml-2"
                                                    hide-details>
                                        </v-checkbox>
                                      </div>
                                      <div class="col-7 pa-0 d-flex flex-wrap">
                                        <i class="std-cow-icon pa-0 mr-2"></i>
                                        <div class="col-6 pa-0">{{ item.idInternal }}</div>
                                      </div>
                                    </div>
                                    <div class="col-6 pa-0 align-center justify-center d-flex">
                                      Filtro
                                    </div>
                                  </v-col>
                                </transition-group>
                              </draggable>
                            </v-row>
                          </v-col>
                          <!-- fin  contenido -->
                        </v-row>
                      </div>
                    </div>
                    <div class="col-1 pa-0 d-flex justify-center">
                      <v-icon x-large class="pa-0"
                              @click="moveAnimals()"
                              :class="{'icon-move' : animMove}">mdi-arrow-right-thick
                      </v-icon>
                    </div>
                    <div class="gf-mid-item d-flex flex-wrap justify-center">
                      <div class="col-8 pa-0 mb-2">
                        <SystemCardCount :number="getFormattedNumber(newGroup.animals.length)"
                                         height="40px"
                                         number-background="#1460AA"
                                         title="Vacas seleccionadas"
                                         title-background="#57A7F5"
                                         width="100%">
                        </SystemCardCount>
                      </div>
                      <div style="height: 265px"
                           class="col-12 pa-0">
                        <!-- inicio tabla eliminación -->
                        <v-row no-gutters
                               class="unselectable mx-2">
                          <!-- inicio header tabla -->
                          <v-col cols="12"
                                 class="d-flex std-text-md-open font-weight-medium">
                            <div class="std-table-header col-12 pa-0 d-flex">
                              <div class="col-6 pa-0 align-center justify-center d-flex"
                                   style="position: relative">
                                <div class="d-flex align-center justify-center"
                                     style="position: absolute; left: 0">
                                </div>
                                ID Vaca
                                <i :class="{'icon-anim' : idSortedIcon}"
                                   @animationend="idSortedIcon = false"
                                   class="std-vertical-arrow-icon std-pointer">
                                </i>
                              </div>
                              <div class="col-6 pa-0 align-center justify-center d-flex">
                                Filtro
                                <i :class="{'icon-anim' : filterSortedIcon}"
                                   @animationend="filterSortedIcon = false"
                                   class="std-vertical-arrow-icon std-pointer">
                                </i>
                              </div>
                            </div>
                          </v-col>
                          <!-- fin header tabla -->
                          <!-- inicio contenido tabla  -->
                          <v-col cols="12"
                                 class="gf-table-content px-2 std-border-bottom-radius gf-draggable-content">
                            <v-row no-gutters
                                   class="mt-2"
                                   align-content="start">
                              <draggable :list="newGroup.animals"
                                         group="animals"
                                         v-bind="dragOptions"
                                         class="d-flex col-12 pa-0 flex-wrap"
                                         @start="drag = true"
                                         @end="drag = false"
                                         @change="log">
                                <transition-group type="transition"
                                                  :name="!drag ? 'flip-list' : null"
                                                  class="d-flex col-12 pa-0 flex-wrap">
                                  <v-col cols="12"
                                         @click="deleteItem(index)"
                                         v-ripple
                                         v-for="item in newGroup.animals"
                                         :key="item.idInternal"
                                         class="std-table-row-container pa-0 d-flex std-text-md-open std-text-gray-3 std-pointer">
                                    <div class="col-6 pa-0 align-center justify-center d-flex flex-wrap"
                                         style="position: relative">
                                      <div class="d-flex align-center justify-center"
                                           style="position: absolute; left: 0">
                                        <v-icon class="pa-0 ma-0 ml-2">mdi-delete-forever</v-icon>
                                      </div>
                                      <div class="col-7 pa-0 d-flex flex-wrap">
                                        <i class="std-cow-icon pa-0 mr-2"></i>
                                        <div class="col-6 pa-0">{{ item.idInternal }}</div>
                                      </div>
                                    </div>
                                    <div class="col-6 pa-0 align-center justify-center d-flex">
                                      Filtro
                                    </div>
                                  </v-col>
                                </transition-group>
                              </draggable>
                            </v-row>
                          </v-col>
                          <!-- fin  contenido -->
                        </v-row>
                        <!-- fin tabla eliminación -->
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin contenedor de inputs 2 -->

              <!-- inicio contenedor de inputs 2 -->
              <v-col cols="12" class="gf-inputs-container" v-if="step === 3">
                <v-row class="mx-6" no-gutters>
                  <!-- inicio de título de primer bloque de inputs -->
                  <v-col cols="12" class="d-flex align-center my-2">
                    <div class="mb-2 std-text-blue-2 font-weight-bold col-3 pa-0"
                         style="font-size: 20px">Selecciona un indicador
                    </div>
                  </v-col>
                  <!-- fin de título de primer bloque de inputs -->
                  <v-col cols="12"
                         class="gf-indicators-container d-flex justify-space-around align-center">
                    <GroupIndicator style="max-width: 23%"
                                    title="Vacas en celo"
                                    :img="heatImage"
                                    :heat="true"
                                    text="Indicador para seguimiento de las fechas de celo para la
                                    inseminación de las vacas"
                                    @click.native="updateKpi('heat')"
                                    :class="{'std-disabled' : newGroup.kpi !== 'heat'}"
                                    class="pa-0">
                    </GroupIndicator>
                    <GroupIndicator style="max-width: 23%"
                                    title="Vacas preñadas"
                                    :img="pregImage"
                                    :class="{'std-disabled' : newGroup.kpi !== 'preg'}"
                                    text="Indicador para seguimiento de las fechas posibles de parto"
                                    @click.native="updateKpi('preg')"
                                    lass="pa-0">
                    </GroupIndicator>
                    <GroupIndicator style="max-width: 23%"
                                    title="Vacas enfermas"
                                    :img="sickImage"
                                    @click.native="updateKpi('sick')"
                                    :class="{'std-disabled' : newGroup.kpi !== 'sick'}"

                                    text="Indicador para dar seguimiento a los tratamientos necesarios"
                                    class="pa-0">
                    </GroupIndicator>
                    <GroupIndicator style="max-width: 23%"
                                    title="DIM"
                                    :img="dimImage"
                                    @click.native="updateKpi('dim')"
                                    :class="{'std-disabled' : newGroup.kpi !== 'dim'}"
                                    text="Indicador de seguimiento de el periodo entre partos y productividad del hato"
                                    class="pa-0">
                    </GroupIndicator>
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin contenedor de inputs 2 -->

              <!-- inicio siguiente paso -->
              <v-col cols="12"
                     class="gf-next-steps-container">
                <v-row class="mx-6 full-height"
                       align="center"
                       :justify="step === 1 ? 'end' : 'space-between'"
                       no-gutters>
                  <v-col cols="2" @click="backGroupForm" v-if="step !== 1">
                    <BackButton></BackButton>
                  </v-col>
                  <v-col cols="2"
                         @click="nextGroupForm()"
                         v-if="step <= 2">
                    <NextButton text="Siguiente" ></NextButton>
                  </v-col>
                  <v-col cols="3"
                         class="std-container-shadow-dense std-border-radius"
                         @click="saveGroup()"
                         v-if="step === 3">
                    <v-btn class="d-flex justify-space-around std-btn-back button-container std-container-shadow-dense"
                           block
                           color="#65D9AC"
                           height="40px"
                           depressed>
                      <div class="d-flex justify-space-between align-center std-text-white-1">
                        Añadir potrero
                        <i class="std-icon std-stall-icon ml-4"></i>
                      </div>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <!-- fin siguiente paso -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<!-- fin de desktop-->

<!-- inicio de movil-->


<!-- fin de movil-->

<script>
  import draggable from 'vuedraggable';
  import getFormattedNumber from '../mixins/formatting'
  import moment from 'moment'
  import {EventBus} from '@/views/bus.js'
  import ChangeRanch from '@/components/ChangeRanch.vue';
  import DashGroupTypeInput from "@/components/DashGroupTypeInput";
  import NextButton from "@/components/NextButton";
  import SystemCardCount from "@/components/SystemCardCount";
  import GroupIndicator from "@/components/GroupIndicator";
  import BackButton from "@/components/BackButton";

export default {
  name: 'GroupForm',
  mixins: [getFormattedNumber],
  data() {
    return {
      newGroup: {
        name: '', // nombre del nuevo grupo
        description: '', // descripción del nuevo grupo
        kpi: 'heat', // el indicador del nuevo grupo
        animals: [],
      },
      type: 'pre',
      nameRules: [
        v => !!v || 'Name is required'
      ],
      ageRule: [
        v => v.length !== 0 || 'One option is required'
      ],
      allRule: [
          v => v === null || 'oki'
      ],
      validOne: false,
      filterType: 'man', // filter type (manual or auto)
      filterOptions: [
        {text: 'Edad (años)', value: 'age'},
        {text: 'Raza', value: 'breed'},
        {text: 'No. de lactancias', value: 'lac'},
      ], // filtros disponibles para aplicar a la selección
      filterSlt: null,
      filterSltOptions: [3, 4, 5, 6, 7],
      filterSltLabels: ['3', '4', '5', '6', '7+'],
      filterSndSlt: [],
      preNames: ['Alta producción', 'Secas o en reto', 'Enfermas'],
      groupFilter: '', // primer filtro aplicado en la selección (Edad en Años, No. de Lactancia o Raza)
      groupFilterSecond: '', // segundo filtro aplicado en la selección, depende del primer filtro
      /**
       * array que se encarga de guardar los números seleccionados si el usuario selecciona como primer
       * filtro No. de Lactancias o Edad en Años
       */
      groupFilterSecondNumber: [],
      filterLabel: '', // filtro con las tags adecuadas para los métodos en la store
      breeds: [ // opciones disponibles si el usuario seleccionó como primer filtro Raza
        'Holstein',
        'Jersey',
        'Simmental',
        'Pardo Suizo',
        'Guernsev',
        'Ayrshire',
        'Shorthorn',
        'Normando Francés',
        'Otra raza'],
      genericRules: [
        v => !!v || 'Campo Requerido',
        v => (v.length > 0) || "Información no válida",
      ],
      groupFormStep: 0,
      groupFormValid: false,
      cowsToAdd: [],
      groupSaved: false,
      allCowsSelected: false,
      step: 1,
      groupSnackActive: false,
      groupSnackText: null,
      filteredAnimals: [],
      animMove: false,
      selectedAnimals: [],
      allSelected: false,
      idSortedIcon: false,
      idOrderFlag: false,
      filterOrderFlag: false,
      filterSortedIcon: false,
      drag: false,
    }
  },
  components: {
    BackButton,
    GroupIndicator,
    SystemCardCount,
    NextButton,
    DashGroupTypeInput,
    ChangeRanch,
    draggable
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    animals() {
      return this.$store.getters.getCows;
    },
    /**
     * DIM image to bind it dynamically
     */
    dimImage() {
      return require('../assets/icons/icon_dim.png');
    },
    /**
     * Sick image
     */
    sickImage() {
      return require('../assets/icons/icon_sick.png');
    },
    pregImage() {
      return require('../assets/icons/icon_pregnant.png');
    },
    heatImage() {
      return require('../assets/icons/icon_heat.png');
    },
  },
  watch: {
    allSelected(val) {
      if (val) {
        this.selectedAnimals = this.filteredAnimals;
      } else {
        this.selectedAnimals = [];
      }
    },
    selectedAnimals(val) {
      this.animMove = val.length !== 0;
    },
    filterSlt(val) {
      if (val === 'breed') {
        this.filterSndSlt = '';
      } else {
        this.filterSndSlt = [];
      }
    },
    animals: {
      handler: function (val) {
        if (val !== [] || !val) {
          let today = moment();
          this.filteredAnimals = val.map(function (cow) {
            cow.age = today.diff(moment(cow.birthday), 'years');
            return cow;
          });
          this.filteredAnimals = val.filter(cow => cow.group === 'Establo general');
        }
      },
      immediate: true,
    },
  },
  methods: {
    resetAnimals() {
      this.filteredAnimals = this.animals.filter(cow => cow.group === 'Establo general');
      this.newGroup.animals = [];
      this.selectedAnimals = [];
    },
    updateKpi(kpi) {
      this.newGroup.kpi = kpi;
    },
    log: function(evt) {
      window.console.log(evt);
      this.selectedAnimals = [];
    },
    /**
     * Deletes one animal from the
     */
    deleteItem(index) {
      let animal = this.newGroup.animals[index]
      this.filteredAnimals.push(animal);
      this.newGroup.animals.splice(index, 1);
    },
    /**
     * Moves the animals selected to the cows selected table
     */
    moveAnimals() {
      if (this.allSelected) {
        this.newGroup.animals = this.filteredAnimals;
        this.filteredAnimals = [];
        this.selectedAnimals = [];
        this.allSelected = false;
      } else {
        this.selectedAnimals.forEach(animal => {
          this.newGroup.animals.push(animal);
          this.filteredAnimals.splice(this.filteredAnimals.indexOf(animal), 1);
        });
        this.selectedAnimals = [];
      }
      this.animMove = false;
    },
    checkFilters() {
      return this.filterSlt !== null && (this.filterSndSlt !== [] || this.filterSlt !== '');
    },
    nextGroupForm() {
      if (this.step === 1) {
        if (this.$refs.formOne.validate()) {
          this.resetAnimals();
          if (this.filterType === 'man') {
            console.log("manual");
            this.step++;
          } else if (this.filterType === 'aut'){
            switch (this.filterSlt) {
              case 'breed':
                this.filteredAnimals = this.filteredAnimals.filter(cow => cow.breed === this.filterSndSlt);
                this.checkEmptyAnimals(this.filteredAnimals);
                break;
              case 'age':
                if (this.filterSndSlt.includes(7)) {
                  this.filteredAnimals = this.filteredAnimals.filter(cow => this.filterSndSlt.includes(cow.age) || cow.age > 7);
                } else {
                  this.filteredAnimals = this.filteredAnimals.filter(cow => this.filterSndSlt.includes(cow.age));
                }
                this.checkEmptyAnimals(this.filteredAnimals);
                break;
              case 'lac':
                if (this.filterSndSlt.includes(7)) {
                  this.filteredAnimals = this.filteredAnimals.filter(cow => this.filterSndSlt.includes(cow.lactationCycle) || cow.dim > 7);
                } else {
                  this.filteredAnimals = this.filteredAnimals.filter(cow => this.filterSndSlt.includes(cow.lactationCycle));
                }
                this.checkEmptyAnimals(this.filteredAnimals);
                break;
              default:
                this.groupSnackText = "Parece que te faltan algunos datos...";
                this.groupSnackActive = true;
                break;
            }
          }
        } else {
          this.groupSnackText = "Parece que te faltan algunos datos...";
          this.groupSnackActive = true;
        }
      } else if (this.step === 2) {
        if (this.newGroup.animals.length === 0) {
          this.groupSnackText = "¡Aún no has añadido ningún animal!";
          this.groupSnackActive = true;
        } else {
          this.step++;
        }
      }
    },
    backGroupForm() {
      this.step--;
    },
    updateSelection(type){
      this.filterType = type;
      this.filterSlt = null;
    },
    /**
     * Check if the filter selection throws an empty array
     * and decides based on that if the user can go ahead
     * with the group register
     */
    checkEmptyAnimals(animals) {
      if (animals.length === 0) {
        this.groupSnackText = "Tu selección arrojó ningún resultado... ¡Intenta probar otro filtro!";
        this.groupSnackActive = true;
      } else {
        this.step++;
      }
    },
    openSectionOnboarding(section) {
      if (this.section === 'DashHome') {
        this.groupFormStep = 0;
        EventBus.$emit('openSectionOnboarding', section);
      } else {
        this.groupFormStep = 0;
        EventBus.$emit('openSectionOnboarding', section);
      }
    },
    deleteCowAdd(cow) {
      for (let i = 0; i < this.cowsToAdd.length; i++) {
        if (this.cowsToAdd[i].id === cow.id) {
          this.cowsToAdd.splice(i, 1);
          break;
        }
      }
      if (this.filteredCows.includes(cow) === false) {
        this.filteredCows.push(cow);
      }
    },
    /**
     * Guarda un nuevo grupo en la base de datos
     */
    saveGroup() {
      this.$store.dispatch('saveGroup', this.newGroup);
      this.$router.push({name: 'DashGroup'});

    },
    backToDashGroup() {
      this.$router.push({name: 'DashGroup'});
    },
  },
  mounted() {
    this.$store.commit('renderNav', true);
  }
};
</script>

<style lang="css">
  @import '../style/GroupForm.css';
</style>
